import tippy, { Placement, Instance } from 'tippy.js'

import { constants } from './tooltip.constant'
import { tooltipSelectors } from './tooltip.selector'

import { useState } from '@/core'

export const TooltipComponent = (() => {
	const { state, setState } = useState({ tooltips: [] as Instance[] })

	const setTooltipInstance = (target: HTMLElement) => {
		if (!target.getAttribute(constants.selector.target)) {
			return
		}

		let targetElement = target as HTMLElement
		if (target.hasAttribute(constants.selector.icon)) {
			const span = document.createElement('span')
			const icon = document.createElement('i')

			icon.className = 'fa-regular fa-circle-question'

			span.appendChild(icon)
			target.appendChild(span)
			targetElement = span
		}

		setState({
			tooltips: [
				...state.tooltips,
				tippy(targetElement, {
					content: target.getAttribute(constants.selector.target) || '',
					placement: (target.getAttribute(constants.selector.placement) as Placement) || 'top',
					theme: 'dark',
					allowHTML: true,
				}),
			],
		})
	}

	const destroy = () => {
		for (let i = 0, { length } = state.tooltips; i < length; i++) {
			state.tooltips[i].destroy()
		}
	}

	const initTargets = () => {
		const targets = tooltipSelectors.getTargets()
		for (let i = 0, { length } = targets; i < length; i++) {
			setTooltipInstance(targets[i])
		}
	}

	const init = () => {
		initTargets()
	}

	return {
		init,
		destroy,
	}
})()
